import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../../constants/dateFormat';
import { encounterStatusMap } from '../../../../../../../../constants/encounter';
import { toBill } from '../../../../../../../../services/financial';
import {
  NS_COMMON,
  NSC_ENCOUNTER,
  NSC_REIMBURSEMENT,
  NSPP_REIMBURSEMENT
} from '../../../../../../../../services/i18n/namespaces';
import { reimbursementStatusesMap } from '../reimbursementConstants';

export default function useReimbursementGridData() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      {
        field: 'eventNumber',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.eventId`),
        flex: 1
      },
      {
        field: 'submittedAt',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.submissionDate`),
        flex: 1,
        valueGetter(value) {
          return value ? moment(value).toDate() : null;
        },
        renderCell({ value }) {
          return value ? moment(value).format(DD_SLASH_MMM_SLASH_YYYY) : '';
        },
        type: 'date',
        align: 'center'
      },
      {
        field: 'submittedByName',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.submittedBy`),
        flex: 1,
        renderCell({ value }) {
          return value || '';
        }
      },
      {
        field: 'encounterDate',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.encounterDate`),
        flex: 1,
        align: 'center',
        valueGetter(value) {
          return value ? moment(value).toDate() : null;
        },
        renderCell({ value, row }) {
          return value ? moment(value).format(DD_SLASH_MMM_SLASH_YYYY) : '';
        },
        type: 'date'
      },
      {
        field: 'encounterName',
        headerName: t(`${NSC_ENCOUNTER}:encounter`),
        flex: 1
      },
      {
        field: 'encounterStatus',
        headerName: t(`${NS_COMMON}:encounterStatus`),
        flex: 1,
        valueGetter(value) {
          return t(`${NSC_ENCOUNTER}:statuses.${encounterStatusMap[value]}`);
        }
      },
      {
        field: 'amount',
        headerName: t(`${NS_COMMON}:amount`),
        flex: 1,
        type: 'number',
        maxWidth: 100,
        valueGetter(value) {
          return toBill(value);
        },
        renderCell({ value }) {
          return `$${value}`;
        }
      },
      {
        field: 'numberOfItems',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.numberOfItems`),
        flex: 1,
        type: 'number',
        maxWidth: 100,
        align: 'center'
      },
      {
        field: 'status',
        headerName: t(`${NSPP_REIMBURSEMENT}:table.status`),
        flex: 1,
        minWidth: 180,
        valueGetter(value) {
          return t(`${NSC_REIMBURSEMENT}:statuses.${reimbursementStatusesMap[value] || value}`);
        }
      }
    ],
    [t]
  );

  return [columns, data, setData];
}
